import { TOKEN } from "../constants/auth";

export const parseJWT = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const getInitialAuthState = () => {
  const token = localStorage.getItem("token");
  if (token) {
    return {
      isAuthenticated: true,
      user: { ...parseJWT(token), branches: [] },
    };
  } else {
    return {
      isAuthenticated: false,
      user: null,
    };
  }
};

export const clearAuthToken = () => {
  window.localStorage.removeItem(TOKEN);
};

export const getAuthToken = () => {
  return window.localStorage.getItem(TOKEN);
};
